import { render } from "./ExternalApi.vue?vue&type=template&id=4e4509ce&ts=true"
import script from "./ExternalApi.vue?vue&type=script&lang=ts"
export * from "./ExternalApi.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__